export default hash => {
	const hashString = hash.substr(1);
	const params = hashString.split('&');
	return params.reduce((object, paramString) => {
		const param = paramString.split('=');
		if (param.length > 1) {
			object[param[0]] = param[1];
		}
		return object;
	}, {});
}
